



import React, { useEffect, useState } from "react";
import {
  Container, Typography, Card, CardContent, CardHeader, Avatar, CircularProgress, Box, Grid, IconButton, Chip, Divider, Paper, Tabs, Tab,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, ButtonGroup, Dialog, DialogTitle, DialogContent, DialogActions,
  Collapse, List, ListItem, ListItemText,
} from "@mui/material";
import manImg from "../../Logos/GenderImages/man.png";
import womanImg from "../../Logos/GenderImages/girl.png";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import ScienceIcon from "@mui/icons-material/Science";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import TableRowsIcon from "@mui/icons-material/TableRows";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useNavigate } from "react-router-dom";
import { fetchUserFromRedis } from "../AuthonticationScreens/Register";
import Footer from "../../Common/Footer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from '@mui/icons-material/Close';
import { apiRequest } from '../../../fetchSetup';


const parseTests = (booking) => {
  try {
    // Check if diagnostic_tests field exists and is not empty
    if (!booking?.diagnostic_tests || booking.diagnostic_tests.trim() === '') {
      return [];
    }

    const diagnosticTests = booking.diagnostic_tests.trim();
    
    // Skip generic placeholder text
    if (diagnosticTests.toUpperCase() === 'DIAGNOSTIC SAMPLE COLLECTION') {
      return [];
    }

    // Parse comma-separated test names (your primary format)
    if (diagnosticTests.includes(',')) {
      return diagnosticTests
        .split(',')
        .map(testName => testName.trim())
        .filter(testName => testName.length > 0)
        .map(testName => ({ 
          test_name: testName,
          name: testName,
          price: 0
        }));
    }
    
    // Single test name
    return [{ 
      test_name: diagnosticTests,
      name: diagnosticTests,
      price: 0
    }];
    
  } catch (error) {
    console.error("Error parsing diagnostic tests:", error);
    console.error("Booking data:", booking);
    return [];
  }
};

const MyComplaints = () => {
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [mainTab, setMainTab] = useState(0);
  const [medicineSubTab, setMedicineSubTab] = useState(0);
  const [viewMode, setViewMode] = useState("table");

  const COMPLAINTS_API = process.env.REACT_APP_MY_COMPLAINTS_API;

  useEffect(() => {
    const fetchUser = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) {
        setUser(null);
        return;
      }
      try {
        const userData = await fetchUserFromRedis(userId, token);
        setUser(userData || null);
      } catch (err) {
        console.error("Error fetching user from Redis:", err);
        setUser(null);
      }
    };
    fetchUser();
  }, []);

  useEffect(() => {
    const fetchComplaints = async () => {
      if (!user) return;

      try {
        const params = new URLSearchParams({
          email: user.email,
          phone: user.phone,
        });

        const res = await apiRequest(`${COMPLAINTS_API}?${params}`);
        const data = await res.json();
        if (res.ok) {
          console.log("Complaints data:", data);
          setComplaints(data.complaints || []);
        } else {
          console.error("Error response:", data.error);
        }
      } catch (err) {
        console.error("Error fetching complaints:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchComplaints();
  }, [user, COMPLAINTS_API]);

  const bookingComplaints = complaints.filter((c) => c.complaint_type === "booking");
  const medicineComplaints = complaints.filter((c) => c.complaint_type === "medicine");
  
  const pharmacyOrders = medicineComplaints.filter(
    (c) => c.medicine_order?.order_type === "pharmacy"
  );
  const prescriptionOrders = medicineComplaints.filter(
    (c) => c.medicine_order?.order_type === "prescription"
  );

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
        <CircularProgress sx={{ color: "#006D77" }} />
      </Box>
    );
  }

  return (
    <>
      <Paper elevation={2} sx={{ bgcolor: "#fff", mb: 3 }}>
        <Container maxWidth="lg">
          <Box sx={{py: { xs: 1.5, sm: 2, md: 3 },display: "flex",alignItems: "center",justifyContent: "space-between",gap: 1, }}>
            <IconButton
              onClick={() => window.history.back()}
              sx={{
                flexShrink: 0,
                backgroundColor: "white",
                boxShadow: 1,
                "&:hover": { backgroundColor: "#f5f5f5" },
              }}
            >
              <ArrowBackIcon />
            </IconButton>

            <Typography
              variant="h4"
              sx={{
                color: "#006D77",
                fontWeight: 600,
                fontSize: { xs: "1rem", sm: "1.4rem", md: "2rem" },
                textAlign: "center",
                flex: 1,
              }}
            >
              My Complaints
            </Typography>

            {/* Spacer to keep title centered */}
            <Box sx={{ width: 40, flexShrink: 0 }} />
          </Box>
        </Container>
      </Paper>

      <Container maxWidth="lg" sx={{ py: 4, mb: 10 }}>
        
        <Paper elevation={1} sx={{ mb: 3 }}>
          <Tabs
            value={mainTab}
            onChange={(e, newValue) => setMainTab(newValue)}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: { xs: "0.8rem", sm: "1rem" },
                fontWeight: 500,
                color: "#006D77",
                px: { xs: 1.5, sm: 3 },
              },
              "& .Mui-selected": { color: "#006D77 !important", fontWeight: 600 },
              "& .MuiTabs-indicator": { backgroundColor: "#006D77", height: 3 },
            }}
          >
            <Tab label="Medicines Delivery" />
            <Tab label="Diagnostics Sample" />
          </Tabs>
        </Paper>


        {mainTab === 0 && (
          <Box>
            <Paper elevation={0} sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={medicineSubTab}
                onChange={(e, newValue) => setMedicineSubTab(newValue)}
                sx={{
                  "& .MuiTab-root": { textTransform: "uppercase", fontSize: "0.875rem", fontWeight: 600, color: "#006D77", minHeight: 48 },
                  "& .Mui-selected": { color: "#006D77 !important" },
                  "& .MuiTabs-indicator": { backgroundColor: "#006D77", height: 3 },
                }}
              >
                <Tab label="Medicine Orders" />
                <Tab label="Prescription Orders" />
              </Tabs>
            </Paper>

            {medicineSubTab === 0 && (
              <Box>



                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      alignItems: { xs: "flex-start", sm: "center" },
                      justifyContent: "space-between",
                      gap: { xs: 1.5, sm: 0 },
                      mb: 3,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <LocalPharmacyIcon sx={{ fontSize: { xs: 24, sm: 32 }, color: "#006D77", mr: 1 }} />
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 600,
                          color: "#006D77",
                          fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                        }}
                      >
                        Medicine Orders {/* Change label per section */}
                      </Typography>
                    </Box>

                    <ButtonGroup variant="outlined" size="small" sx={{ flexShrink: 0 }}>
                      <Button
                        onClick={() => setViewMode("card")}
                        variant={viewMode === "card" ? "contained" : "outlined"}
                        startIcon={<ViewModuleIcon />}
                        sx={{
                          bgcolor: viewMode === "card" ? "#006D77" : "transparent",
                          color: viewMode === "card" ? "white" : "#006D77",
                          borderColor: "#006D77",
                          px: { xs: 1, sm: 2 },
                          fontSize: { xs: "0.7rem", sm: "0.875rem" },
                          "&:hover": {
                            bgcolor: viewMode === "card" ? "#004F55" : "#E0F7FA",
                            borderColor: "#006D77",
                          },
                        }}
                      >
                        <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                          Card View
                        </Box>
                      </Button>
                      <Button
                        onClick={() => setViewMode("table")}
                        variant={viewMode === "table" ? "contained" : "outlined"}
                        startIcon={<TableRowsIcon />}
                        sx={{
                          bgcolor: viewMode === "table" ? "#006D77" : "transparent",
                          color: viewMode === "table" ? "white" : "#006D77",
                          borderColor: "#006D77",
                          px: { xs: 1, sm: 2 },
                          fontSize: { xs: "0.7rem", sm: "0.875rem" },
                          "&:hover": {
                            bgcolor: viewMode === "table" ? "#004F55" : "#E0F7FA",
                            borderColor: "#006D77",
                          },
                        }}
                      >
                        <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                          Table View
                        </Box>
                      </Button>
                    </ButtonGroup>
                  </Box>
                <Typography variant="body2" sx={{ mb: 3, color: "#666" }}>
                  Manage pharmacy medicine orders ({pharmacyOrders.length} total)
                </Typography>

                {pharmacyOrders.length === 0 ? (
                  <Box textAlign="center" sx={{ py: 8 }}>
                    <Typography sx={{ fontSize: 50, mb: 2 }}>💊</Typography>
                    <Typography sx={{ fontSize: 20, fontWeight: 700, color: "#111827", mb: 1 }}>No Medicine Order Compliants Found</Typography>
                    <Typography sx={{ color: "#6B7280", fontSize: 14 }}>You currently have no pharmacy medicine order complaints.</Typography>
                  </Box>
                ) : viewMode === "card" ? (
                  <Grid container spacing={3}>
                    {pharmacyOrders.map((c) => (
                      <Grid item xs={12} sm={6} md={6} key={c.complaint_id || Math.random()}>
                        <MedicineComplaintCard complaint={c} />
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <MedicineComplaintTable complaints={pharmacyOrders} />
                )}
              </Box>
            )}

            {medicineSubTab === 1 && (
              <Box>


                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "center" },
                    justifyContent: "space-between",
                    gap: { xs: 1.5, sm: 0 },
                    mb: 3,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <LocalPharmacyIcon sx={{ fontSize: { xs: 24, sm: 32 }, color: "#006D77", mr: 1 }} />
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 600,
                        color: "#006D77",
                        fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                      }}
                    >
                    Prescription Orders
                    </Typography>
                  </Box>

                  <ButtonGroup variant="outlined" size="small" sx={{ flexShrink: 0 }}>
                    <Button
                      onClick={() => setViewMode("card")}
                      variant={viewMode === "card" ? "contained" : "outlined"}
                      startIcon={<ViewModuleIcon />}
                      sx={{
                        bgcolor: viewMode === "card" ? "#006D77" : "transparent",
                        color: viewMode === "card" ? "white" : "#006D77",
                        borderColor: "#006D77",
                        px: { xs: 1, sm: 2 },
                        fontSize: { xs: "0.7rem", sm: "0.875rem" },
                        "&:hover": {
                          bgcolor: viewMode === "card" ? "#004F55" : "#E0F7FA",
                          borderColor: "#006D77",
                        },
                      }}
                    >
                      <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                        Card View
                      </Box>
                    </Button>
                    <Button
                      onClick={() => setViewMode("table")}
                      variant={viewMode === "table" ? "contained" : "outlined"}
                      startIcon={<TableRowsIcon />}
                      sx={{
                        bgcolor: viewMode === "table" ? "#006D77" : "transparent",
                        color: viewMode === "table" ? "white" : "#006D77",
                        borderColor: "#006D77",
                        px: { xs: 1, sm: 2 },
                        fontSize: { xs: "0.7rem", sm: "0.875rem" },
                        "&:hover": {
                          bgcolor: viewMode === "table" ? "#004F55" : "#E0F7FA",
                          borderColor: "#006D77",
                        },
                      }}
                    >
                      <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                        Table View
                      </Box>
                    </Button>
                  </ButtonGroup>
                </Box>
                <Typography variant="body2" sx={{ mb: 3, color: "#666" }}>
                  Manage prescription orders ({prescriptionOrders.length} total)
                </Typography>

                {prescriptionOrders.length === 0 ? (
                  <Box textAlign="center" sx={{ py: 8 }}>
                    <Typography sx={{ fontSize: 50, mb: 2 }}>📋</Typography>
                    <Typography sx={{ fontSize: 20, fontWeight: 700, color: "#111827", mb: 1 }}>No Prescription Orders Found</Typography>
                    <Typography sx={{ color: "#6B7280", fontSize: 14 }}>You currently have no prescription order complaints.</Typography>
                  </Box>
                ) : viewMode === "card" ? (
                  <Grid container spacing={3}>
                    {prescriptionOrders.map((c) => (
                      <Grid item xs={12} sm={6} md={6} key={c.complaint_id || Math.random()}>
                        <MedicineComplaintCard complaint={c} />
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <MedicineComplaintTable complaints={prescriptionOrders} />
                )}
              </Box>
            )}
          </Box>
        )}

        {mainTab === 1 && (
          <Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: "space-between",
                gap: { xs: 1.5, sm: 0 },
                mb: 3,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <ScienceIcon sx={{ fontSize: { xs: 24, sm: 32 }, color: "#006D77", mr: 1 }} />
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    color: "#006D77",
                    fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                  }}
                >
                  Diagnostic Orders 
                </Typography>
              </Box>

              <ButtonGroup variant="outlined" size="small" sx={{ flexShrink: 0 }}>
                <Button
                  onClick={() => setViewMode("card")}
                  variant={viewMode === "card" ? "contained" : "outlined"}
                  startIcon={<ViewModuleIcon />}
                  sx={{
                    bgcolor: viewMode === "card" ? "#006D77" : "transparent",
                    color: viewMode === "card" ? "white" : "#006D77",
                    borderColor: "#006D77",
                    px: { xs: 1, sm: 2 },
                    fontSize: { xs: "0.7rem", sm: "0.875rem" },
                    "&:hover": {
                      bgcolor: viewMode === "card" ? "#004F55" : "#E0F7FA",
                      borderColor: "#006D77",
                    },
                  }}
                >
                  <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                    Card View
                  </Box>
                </Button>
                <Button
                  onClick={() => setViewMode("table")}
                  variant={viewMode === "table" ? "contained" : "outlined"}
                  startIcon={<TableRowsIcon />}
                  sx={{
                    bgcolor: viewMode === "table" ? "#006D77" : "transparent",
                    color: viewMode === "table" ? "white" : "#006D77",
                    borderColor: "#006D77",
                    px: { xs: 1, sm: 2 },
                    fontSize: { xs: "0.7rem", sm: "0.875rem" },
                    "&:hover": {
                      bgcolor: viewMode === "table" ? "#004F55" : "#E0F7FA",
                      borderColor: "#006D77",
                    },
                  }}
                >
                  <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                    Table View
                  </Box>
                </Button>
              </ButtonGroup>
            </Box>
            <Typography variant="body2" sx={{ mb: 3, color: "#666" }}>
              Manage diagnostic sample orders ({bookingComplaints.length} total)
            </Typography>

            {bookingComplaints.length === 0 ? (
              <Box textAlign="center" sx={{ py: 8 }}>
                <Typography sx={{ fontSize: 50, mb: 2 }}>🔬</Typography>
                <Typography sx={{ fontSize: 20, fontWeight: 700, color: "#111827", mb: 1 }}>No Diagnostic Orders Found</Typography>
                <Typography sx={{ color: "#6B7280", fontSize: 14 }}>You currently have no diagnostic order complaints.</Typography>
              </Box>
            ) : viewMode === "card" ? (
              <Grid container spacing={3}>
                {bookingComplaints.map((c) => (
                  <Grid item xs={12} sm={6} md={6} key={c.complaint_id || Math.random()}>
                    <BookingComplaintCard complaint={c} />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <BookingComplaintTable complaints={bookingComplaints} />
            )}
          </Box>
        )}
      </Container>
      <Footer />
    </>
  );
};

// BOOKING COMPLAINT CARD COMPONENT (DIAGNOSTICS)
const BookingComplaintCard = ({ complaint }) => {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "resolved": return "#38A169";
      case "pending": return "#DD6B20";
      case "in_progress": return "#3182CE";
      default: return "#718096";
    }
  };

  const tests = parseTests(complaint.booking);
  
  // Debug logging
  useEffect(() => {
    console.log("BookingComplaintCard - Complaint ID:", complaint.complaint_id);
    console.log("BookingComplaintCard - Raw diagnostic_tests:", complaint.booking?.diagnostic_tests);
    console.log("BookingComplaintCard - Parsed tests:", tests);
  }, [complaint, tests]);

  return (
    <>
      <Card
        sx={{
          backgroundColor: "#fff",
          borderRadius: 3,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          transition: "all 0.3s ease",
          "&:hover": { transform: "translateY(-4px)", boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.15)" },
          height: "100%",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #e0e0e0",
        }}
      >
        <CardHeader
          avatar={
            <Avatar sx={{ bgcolor: "transparent", width: 70, height: 70 }}>
              <img
                src={complaint.booking?.gender?.toLowerCase() === "male" ? manImg : womanImg}
                alt={complaint.booking?.gender || "Patient"}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Avatar>
          }
          title={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <LocalHospitalIcon sx={{ color: "#38A169", fontSize: 20 }} />
              <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "1rem" }}>
                Diagnostic Test
              </Typography>
            </Box>
          }
          subheader={
            <Chip
              label={complaint.status?.toUpperCase() || "PENDING"}
              size="small"
              sx={{
                backgroundColor: getStatusColor(complaint.status),
                color: "white",
                fontWeight: 600,
                mt: 1,
                fontSize: "0.7rem",
                pointerEvents: "none"
              }}
            />
          }
          sx={{ pb: 1 }}
        />
        <CardContent sx={{ flexGrow: 1, pt: 1 }}>
          {/* Selected Tests Preview */}
          {tests.length > 0 && (
            <Box sx={{ mb: 2, p: 1.5, backgroundColor: "#F0F9FF", borderRadius: 1, border: "1px solid #006D77" }}>
              <Typography variant="caption" sx={{ fontWeight: 600, mb: 0.5, display: "block", color: "#006D77" }}>
                🔬 Selected Tests ({tests.length}):
              </Typography>
              {tests.slice(0, 2).map((test, idx) => (
                <Typography key={idx} variant="body2" sx={{ fontSize: "0.85rem", mb: 0.3 }}>
                  • {test.test_name || test.name || "Unknown Test"}
                </Typography>
              ))}
              {tests.length > 2 && (
                <Typography variant="caption" sx={{ color: "#666", mt: 0.5, display: "block", fontSize: "0.75rem" }}>
                  +{tests.length - 2} more tests
                </Typography>
              )}
            </Box>
          )}

          <Typography variant="body2" sx={{ mb: 1, fontSize: "0.875rem" }}>
            <strong>Category:</strong> {complaint.category || "N/A"}
          </Typography>
          <Typography variant="body2" sx={{ mb: 1, fontSize: "0.875rem" }}>
            <strong>Complaint ID:</strong> {complaint.complaint_id || "N/A"}
          </Typography>
          
          <Divider sx={{ my: 2 }} />
          
          <Typography variant="body2" sx={{ mb: 1, fontSize: "0.875rem" }}>
            <strong>Booking Date:</strong>{" "}
            {complaint.booking?.date ? new Date(complaint.booking.date).toLocaleDateString("en-IN") : "-"}
          </Typography>

          {complaint.feedback && (
            <Box sx={{ mt: 2, p: 1.5, backgroundColor: "#E6FFFA", borderRadius: 1, border: "1px solid #99F6E4" }}>
              <Typography variant="caption" sx={{ fontWeight: 600, color: "#006D77" }}>💬 Feedback:</Typography>
              <Typography variant="body2" sx={{ mt: 0.5, fontSize: "0.85rem" }}>
                {complaint.feedback.comment ? complaint.feedback.comment : JSON.stringify(complaint.feedback)}
              </Typography>
            </Box>
          )}

          {complaint.created_at && (
            <Typography variant="caption" sx={{ color: "#666", mt: 2, display: "block", fontSize: "0.75rem" }}>
              📅 Reported on: {new Intl.DateTimeFormat("en-IN", {
                day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Asia/Kolkata"
              }).format(new Date(complaint.created_at))}
            </Typography>
          )}

          <Button
            fullWidth
            variant="outlined"
            startIcon={<VisibilityIcon />}
            onClick={() => setDetailsOpen(true)}
            sx={{
              mt: 2,
              borderColor: "#006D77",
              color: "#006D77",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { bgcolor: "#E0F7FA", borderColor: "#004F55" }
            }}
          >
            View Order Details
          </Button>
        </CardContent>
      </Card>

      <OrderDetailsDialog open={detailsOpen} onClose={() => setDetailsOpen(false)} complaint={complaint} />
    </>
  );
};

// ============================================================================
// MEDICINE COMPLAINT CARD COMPONENT
// ============================================================================
const MedicineComplaintCard = ({ complaint }) => {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "resolved": return "#38A169";
      case "pending": return "#DD6B20";
      case "in_progress": return "#3182CE";
      default: return "#718096";
    }
  };

  return (
    <>
      <Card
        sx={{
          backgroundColor: "#fff",
          borderRadius: 3,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          transition: "all 0.3s ease",
          "&:hover": { transform: "translateY(-4px)", boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.15)" },
          height: "100%",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #e0e0e0",
        }}
      >
        <CardHeader
          avatar={
            <Avatar sx={{ bgcolor: "#006D77", width: 70, height: 70 }}>
              <LocalPharmacyIcon sx={{ fontSize: 36, color: "white" }} />
            </Avatar>
          }
          title={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <LocalPharmacyIcon sx={{ color: "#006D77", fontSize: 20 }} />
              <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "1rem" }}>Medicine Order</Typography>
            </Box>
          }
          subheader={
            <Chip
              label={complaint.status?.toUpperCase() || "PENDING"}
              size="small"
              sx={{
                backgroundColor: getStatusColor(complaint.status),
                color: "white",
                fontWeight: 600,
                mt: 1,
                fontSize: "0.7rem",
                pointerEvents: "none"
              }}
            />
          }
          sx={{ pb: 1 }}
        />
        <CardContent sx={{ flexGrow: 1, pt: 1 }}>
          <Typography variant="body2" sx={{ mb: 1, fontSize: "0.875rem" }}>
            <strong>Category:</strong> {complaint.category || "N/A"}
          </Typography>
          {complaint.description && (
            <Typography variant="body2" sx={{ mb: 1, fontSize: "0.875rem" }}>
              <strong>Description:</strong> {complaint.description}
            </Typography>
          )}
          
          <Divider sx={{ my: 2 }} />
          
          <Typography variant="body2" sx={{ mb: 0.5, fontSize: "0.875rem" }}>
            <strong>Order ID:</strong> {complaint.medicine_order?.order_id || "N/A"}
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5, fontSize: "0.875rem" }}>
            <strong>Order Type:</strong>{" "}
            <Chip
              label={complaint.medicine_order?.order_type === "prescription" ? "PRESCRIPTION" : "PHARMACY"}
              size="small"
              sx={{
                fontSize: "0.7rem",
                ml: 0.5,
                bgcolor: complaint.medicine_order?.order_type === "prescription" ? "#DBEAFE" : "#E0E7FF",
                color: complaint.medicine_order?.order_type === "prescription" ? "#1E40AF" : "#4338CA",
                fontWeight: 600,
                pointerEvents: "none"
              }}
            />
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5, fontSize: "0.875rem" }}>
            <strong>Order Status:</strong>{" "}
            <Chip
              label={
                complaint.medicine_order?.order_status?.toLowerCase() === "awaiting_bill"
                  ? "PENDING"
                  : complaint.medicine_order?.order_status?.replace(/_/g, " ")?.toUpperCase()
              }
              size="small"
              sx={{ fontSize: "0.7rem", ml: 0.5, pointerEvents: "none" }}
            />
          </Typography>

          <Typography variant="body2" sx={{ mb: 1, fontSize: "0.875rem", fontWeight: 600, color: "#006D77" }}>
            <strong>Total Amount:</strong> ₹{complaint.medicine_order?.total_amount || 0}
          </Typography>

          {complaint.medicine_order?.items && complaint.medicine_order.items.length > 0 && (
            <Box sx={{ mt: 2, p: 1.5, backgroundColor: "#F0F9FF", borderRadius: 1, border: "1px solid #006D77" }}>
              <Typography variant="caption" sx={{ fontWeight: 600, mb: 0.5, display: "block", color: "#006D77" }}>
                💊 Items ({complaint.medicine_order.items_count || complaint.medicine_order.items.length}):
              </Typography>
              {complaint.medicine_order.items.slice(0, 2).map((item, idx) => (
                <Typography key={idx} variant="body2" sx={{ fontSize: "0.85rem", mb: 0.3 }}>
                  • {item.medicine_name} (Qty: {item.quantity}) - ₹{item.total_price}
                </Typography>
              ))}
              {complaint.medicine_order.items.length > 2 && (
                <Typography variant="caption" sx={{ color: "#666", mt: 0.5, display: "block", fontSize: "0.75rem" }}>
                  +{complaint.medicine_order.items.length - 2} more items
                </Typography>
              )}
            </Box>
          )}

          {complaint.created_at && (
            <Typography variant="caption" sx={{ color: "#666", mt: 2, display: "block", fontSize: "0.75rem" }}>
              📅 Reported on: {new Intl.DateTimeFormat("en-IN", {
                day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Asia/Kolkata"
              }).format(new Date(complaint.created_at))}
            </Typography>
          )}

          <Button
            fullWidth
            variant="outlined"
            startIcon={<VisibilityIcon />}
            onClick={() => setDetailsOpen(true)}
            sx={{
              mt: 2,
              borderColor: "#006D77",
              color: "#006D77",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { bgcolor: "#E0F7FA", borderColor: "#004F55" }
            }}
          >
            View Order Details
          </Button>
        </CardContent>
      </Card>

      <OrderDetailsDialog open={detailsOpen} onClose={() => setDetailsOpen(false)} complaint={complaint} />
    </>
  );
};

// ============================================================================
// ORDER DETAILS DIALOG COMPONENT
// ============================================================================
const OrderDetailsDialog = ({ open, onClose, complaint }) => {
  const isMedicineOrder = complaint?.complaint_type === "medicine";
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3 }
      }}
    >
      <DialogTitle sx={{ 
        bgcolor: "#006D77", 
        color: "white", 
        display: "flex", 
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {isMedicineOrder ? "Medicine Order Details" : "Service Booking Details"}
        </Typography>
        <IconButton onClick={onClose} sx={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ mt: 2 }}>
        {isMedicineOrder ? (
          <MedicineOrderDetails order={complaint.medicine_order} />
        ) : (
          <BookingOrderDetails booking={complaint.booking} />
        )}
      </DialogContent>
      
      <DialogActions sx={{ p: 2 }}>
        <Button 
          onClick={onClose}
          variant="contained"
          sx={{
            bgcolor: "#006D77",
            textTransform: "none",
            px: 3,
            '&:hover': { bgcolor: '#004F55' }
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// MEDICINE ORDER DETAILS COMPONENT
const MedicineOrderDetails = ({ order }) => {
  return (
    <Box>
      {/* Order Summary */}
      <Paper sx={{ p: 2, mb: 3, bgcolor: "#F0F9FF", border: "1px solid #006D77" }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: "#006D77", mb: 2 }}>
          📋 Order Summary
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Order ID:</Typography>
            <Typography variant="body2" color="text.secondary">{order?.order_id || "N/A"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Order Type:</Typography>
            <Chip
              label={order?.order_type === "prescription" ? "PRESCRIPTION" : "PHARMACY"}
              size="small"
              sx={{
                fontSize: "0.7rem",
                bgcolor: order?.order_type === "prescription" ? "#DBEAFE" : "#E0E7FF",
                color: order?.order_type === "prescription" ? "#1E40AF" : "#4338CA",
                fontWeight: 600,
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Order Status:</Typography>
            <Chip
              label={
                order?.order_status?.toLowerCase() === "awaiting_bill"
                  ? "PENDING"
                  : order?.order_status?.replace(/_/g, " ")?.toUpperCase() || "N/A"
              }
              size="small"
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Delivery Status:</Typography>
            <Typography variant="body2" color="text.secondary">
              {order?.delivery_status?.replace(/_/g, " ")?.toUpperCase() || "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Order Date:</Typography>
            <Typography variant="body2" color="text.secondary">
              {order?.created_at ? new Date(order.created_at).toLocaleDateString("en-IN") : "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Total Amount:</Typography>
            <Typography variant="body2" sx={{ fontWeight: 700, color: "#006D77", fontSize: "1.1rem" }}>
              ₹{order?.total_amount || 0}
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      {/* Patient Details */}
      {(order?.patient_name || order?.patient_age || order?.patient_gender || order?.patient_phone) && (
        // <Paper sx={{ p: 2, mb: 3, bgcolor: "#FFF7ED", border: "1px solid #FB923C" }}>
        <Paper sx={{ p: 2, mb: 3, bgcolor: "#F0F9FF", border: "1px solid #006D77" }}>
          <Typography variant="h6" sx={{ fontWeight: 700, color: "#006D77", mb: 2 }}>
            👤 Patient Information
          </Typography>
          <Grid container spacing={2}>
            {order.patient_name && (
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>Name:</Typography>
                <Typography variant="body2" color="text.secondary">{order.patient_name}</Typography>
              </Grid>
            )}
            {order.patient_age && (
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>Age:</Typography>
                <Typography variant="body2" color="text.secondary">{order.patient_age}</Typography>
              </Grid>
            )}
            {order.patient_gender && (
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>Gender:</Typography>
                <Typography variant="body2" color="text.secondary">{order.patient_gender}</Typography>
              </Grid>
            )}
            {order.patient_phone && (
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>Phone:</Typography>
                <Typography variant="body2" color="text.secondary">{order.patient_phone}</Typography>
              </Grid>
            )}
            {order.patient_doctor && (
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>Doctor:</Typography>
                <Typography variant="body2" color="text.secondary">{order.patient_doctor}</Typography>
              </Grid>
            )}
          </Grid>
        </Paper>
      )}

      {/* Items List */}
      {order?.items && order.items.length > 0 && (
        <Paper sx={{ p: 2, bgcolor: "#F9FAFB", border: "1px solid #E5E7EB" }}>
          <Typography variant="h6" sx={{ fontWeight: 700, color: "#006D77", mb: 2 }}>
            💊 Ordered Items ({order.items.length})
          </Typography>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: "#006D77" }}>
                  <TableCell sx={{ color: "white", fontWeight: 700 }}>Medicine Name</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 700 }} align="center">Quantity</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: 700 }} align="right">Price</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {order.items.map((item, idx) => (
                  <TableRow key={idx} sx={{ "&:nth-of-type(odd)": { bgcolor: "#FAFAFA" } }}>
                    <TableCell>{item.medicine_name}</TableCell>
                    <TableCell align="center">{item.quantity}</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 600 }}>₹{item.total_price}</TableCell>
                  </TableRow>
                ))}
                <TableRow sx={{ bgcolor: "#E0F7FA" }}>
                  <TableCell colSpan={2} sx={{ fontWeight: 700 }}>Total</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 700, color: "#006D77", fontSize: "1.1rem" }}>
                    ₹{order.total_amount}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
    </Box>
  );
};

// BOOKING ORDER DETAILS COMPONENT
const BookingOrderDetails = ({ booking }) => {
  const tests = parseTests(booking);
  
  // Debug logging
  useEffect(() => {
    console.log("BookingOrderDetails - Raw diagnostic_tests:", booking?.diagnostic_tests);
    console.log("BookingOrderDetails - Parsed tests:", tests);
  }, [booking, tests]);

  return (
    <Box>
      {/* Booking Summary */}
      <Paper sx={{ p: 2, mb: 3, bgcolor: "#F0F9FF", border: "1px solid #006D77" }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: "#006D77", mb: 2 }}>
          📋 Booking Summary
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Booking ID:</Typography>
            <Typography variant="body2" color="text.secondary">{booking?.booking_id || "N/A"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Status:</Typography>
            <Chip
              label={booking?.status?.toUpperCase() || "N/A"}
              size="small"
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Booking Date:</Typography>
            <Typography variant="body2" color="text.secondary">
              {booking?.date ? new Date(booking.date).toLocaleDateString("en-IN") : "N/A"}
            </Typography>
          </Grid>
          {tests.length > 0 && (
            <Grid item xs={6}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>Total Tests:</Typography>
              <Typography variant="body2" color="text.secondary">{tests.length}</Typography>
            </Grid>
          )}
        </Grid>
      </Paper>

      {/* Patient Details */}
      <Paper sx={{ p: 2, mb: 3, bgcolor: "#FFF7ED", border: "1px solid #FB923C" }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: "#EA580C", mb: 2 }}>
          👤 Patient Information
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Name:</Typography>
            <Typography variant="body2" color="text.secondary">{booking?.name || "N/A"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Age:</Typography>
            <Typography variant="body2" color="text.secondary">{booking?.age || "N/A"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>Gender:</Typography>
            <Typography variant="body2" color="text.secondary">{booking?.gender || "N/A"}</Typography>
          </Grid>
          {booking?.phone && (
            <Grid item xs={6}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>Phone:</Typography>
              <Typography variant="body2" color="text.secondary">{booking.phone}</Typography>
            </Grid>
          )}
        </Grid>
      </Paper>

      {/* Selected Tests */}
      {tests.length > 0 && (
        <Paper sx={{ p: 2, bgcolor: "#F9FAFB", border: "1px solid #E5E7EB" }}>
          <Typography variant="h6" sx={{ fontWeight: 700, color: "#006D77", mb: 2 }}>
            🔬 Selected Tests ({tests.length})
          </Typography>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: "#006D77" }}>
                  <TableCell sx={{ color: "white", fontWeight: 700 }}>Test Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tests.map((test, idx) => (
                  <TableRow key={idx} sx={{ "&:nth-of-type(odd)": { bgcolor: "#FAFAFA" } }}>
                    <TableCell>{test.test_name || test.name || "-"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
    </Box>
  );
};

// BOOKING COMPLAINT TABLE COMPONENT
const BookingComplaintTable = ({ complaints }) => {
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "resolved": return "#38A169";
      case "pending": return "#DD6B20";
      case "in_progress": return "#3182CE";
      default: return "#718096";
    }
  };

  const toggleRowExpansion = (complaintId) => {
    setExpandedRows(prev => ({
      ...prev,
      [complaintId]: !prev[complaintId]
    }));
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#006D77" }}>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Patient Name</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Age/Gender</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Phone</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Tests</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Category</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Status</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Booking Date</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Reported Date</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {complaints.map((complaint, index) => {
              const tests = parseTests(complaint.booking);
              const isExpanded = expandedRows[complaint.complaint_id];
              
              return (
                <React.Fragment key={complaint.complaint_id || index}>
                  <TableRow
                    sx={{
                      "&:hover": { bgcolor: "#F0F9FF" },
                      "&:nth-of-type(odd)": { bgcolor: "#FAFAFA" },
                    }}
                  >
                    <TableCell>{complaint.booking?.name || "-"}</TableCell>
                    <TableCell>
                      {complaint.booking?.age || "-"} / {complaint.booking?.gender || "-"}
                    </TableCell>
                    <TableCell>{complaint.booking?.phone || "-"}</TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Chip
                          label={`${tests.length} test${tests.length !== 1 ? 's' : ''}`}
                          size="small"
                          sx={{ bgcolor: "#E0F7FA", color: "#006D77", fontWeight: 600, pointerEvents: "none" }}
                        />
                        {tests.length > 0 && (
                          <IconButton
                            size="small"
                            onClick={() => toggleRowExpansion(complaint.complaint_id)}
                            sx={{ color: "#006D77" }}
                          >
                            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                          </IconButton>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>{complaint.category || "N/A"}</TableCell>
                    {/* <TableCell>{complaint.booking?.diagnostic_tests || "N/A"}</TableCell> */}
                    <TableCell>
                      <Chip
                        label={complaint.status?.toUpperCase() || "PENDING"}
                        size="small"
                        sx={{
                          backgroundColor: getStatusColor(complaint.status),
                          color: "white",
                          fontWeight: 600,
                          fontSize: "0.7rem",
                          pointerEvents: "none"
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      {complaint.booking?.date
                        ? new Date(complaint.booking.date).toLocaleDateString("en-IN")
                        : "-"}
                    </TableCell>
                    <TableCell>
                      {complaint.created_at
                        ? new Intl.DateTimeFormat("en-IN", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            timeZone: "Asia/Kolkata",
                          }).format(new Date(complaint.created_at))
                        : "-"}
                    </TableCell>
                    <TableCell>
                      <Button
                        size="small"
                        variant="outlined"
                        startIcon={<VisibilityIcon />}
                        onClick={() => {
                          setSelectedComplaint(complaint);
                          setDetailsOpen(true);
                        }}
                        sx={{
                          borderColor: "#006D77",
                          color: "#006D77",
                          textTransform: "none",
                          fontSize: "0.75rem",
                          "&:hover": {
                            bgcolor: "#E0F7FA",
                          }
                        }}
                      >
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                  
                  {/* Expandable Row for Tests */}
                  {tests.length > 0 && (
                    <TableRow>
                      <TableCell colSpan={9} sx={{ py: 0, borderBottom: isExpanded ? "1px solid #e0e0e0" : "none" }}>
                        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                          <Box sx={{ p: 2, bgcolor: "#F0F9FF" }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#006D77", mb: 1 }}>
                              🔬 Selected Tests:
                            </Typography>
                            <List dense>
                              {tests.map((test, idx) => (
                                <ListItem key={idx} sx={{ py: 0.5 }}>
                                  <ListItemText
                                    primary={test.test_name || test.name || "-"}
                                    secondary={test.price ? `₹${test.price}` : "Price not available"}
                                    primaryTypographyProps={{ fontSize: "0.875rem" }}
                                    secondaryTypographyProps={{ fontSize: "0.75rem" }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {selectedComplaint && (
        <OrderDetailsDialog
          open={detailsOpen}
          onClose={() => {
            setDetailsOpen(false);
            setSelectedComplaint(null);
          }}
          complaint={selectedComplaint}
        />
      )}
    </>
  );
};

// MEDICINE COMPLAINT TABLE COMPONENT
const MedicineComplaintTable = ({ complaints }) => {
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "resolved": return "#38A169";
      case "pending": return "#DD6B20";
      case "in_progress": return "#3182CE";
      default: return "#718096";
    }
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#006D77" }}>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Patient Name</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Age/Gender</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Phone</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Order ID</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Order Type</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Category</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Status</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Total Amount</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Items</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Reported Date</TableCell>
              <TableCell sx={{ color: "white", fontWeight: 700 }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {complaints.map((complaint, index) => (
              <TableRow
                key={complaint.complaint_id || index}
                sx={{
                  "&:hover": { bgcolor: "#F0F9FF" },
                  "&:nth-of-type(odd)": { bgcolor: "#FAFAFA" },
                }}
              >
                <TableCell>{complaint.medicine_order?.patient_name || "-"}</TableCell>
                <TableCell>
                  {complaint.medicine_order?.patient_age || "-"} /{" "}
                  {complaint.medicine_order?.patient_gender || "-"}
                </TableCell>
                <TableCell>{complaint.medicine_order?.patient_phone || "-"}</TableCell>
                <TableCell>{complaint.medicine_order?.order_id || "N/A"}</TableCell>
                <TableCell>
                  <Chip
                    label={
                      complaint.medicine_order?.order_type === "prescription"
                        ? "PRESCRIPTION"
                        : "PHARMACY"
                    }
                    size="small"
                    sx={{
                      fontSize: "0.7rem",
                      bgcolor:
                        complaint.medicine_order?.order_type === "prescription"
                          ? "#DBEAFE"
                          : "#E0E7FF",
                      color:
                        complaint.medicine_order?.order_type === "prescription"
                          ? "#1E40AF"
                          : "#4338CA",
                      fontWeight: 600,
                      pointerEvents: "none"
                    }}
                  />
                </TableCell>
                <TableCell>{complaint.category || "N/A"}</TableCell>
                <TableCell>
                  <Chip
                    label={complaint.status?.toUpperCase() || "PENDING"}
                    size="small"
                    sx={{
                      backgroundColor: getStatusColor(complaint.status),
                      color: "white",
                      fontWeight: 600,
                      fontSize: "0.7rem",
                      pointerEvents: "none"
                    }}
                  />
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: "#006D77" }}>
                  ₹{complaint.medicine_order?.total_amount || 0}
                </TableCell>
                <TableCell>
                  {complaint.medicine_order?.items_count || complaint.medicine_order?.items?.length || 0}
                </TableCell>
                <TableCell>
                  {complaint.created_at
                    ? new Intl.DateTimeFormat("en-IN", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        timeZone: "Asia/Kolkata",
                      }).format(new Date(complaint.created_at))
                    : "-"}
                </TableCell>
                <TableCell>
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<VisibilityIcon />}
                    onClick={() => {
                      setSelectedComplaint(complaint);
                      setDetailsOpen(true);
                    }}
                    sx={{
                      borderColor: "#006D77",
                      color: "#006D77",
                      textTransform: "none",
                      fontSize: "0.75rem",
                      "&:hover": {
                        bgcolor: "#E0F7FA",
                      }
                    }}
                  >
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {selectedComplaint && (
        <OrderDetailsDialog
          open={detailsOpen}
          onClose={() => {
            setDetailsOpen(false);
            setSelectedComplaint(null);
          }}
          complaint={selectedComplaint}
        />
      )}
    </>
  );
};

export default MyComplaints;